module.exports = __webpack_public_path__ + "t.no1.0c824dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/t.no1.jpg
// module id = 4Xzq
// module chunks = 0